import React from 'react';
import { AxiosError } from 'axios';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ServerErrorPage } from '@app/pages/shared';
import NoMatchPage from '@app/pages/shared/NoMatch';
import { isMaintenanceMode } from '@data/utils/helpers';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  function FallbackComponent({ error }: { error: AxiosError; resetErrorBoundary: () => void }) {
    return (
      <div>
        {error?.response?.status === 404 ? (
          <NoMatchPage />
        ) : (
          (!error?.response?.status ||
            (!isMaintenanceMode(error) && error?.response?.status >= 500)) && <ServerErrorPage />
        )}
      </div>
    );
  }

  return <ReactErrorBoundary FallbackComponent={FallbackComponent}>{children}</ReactErrorBoundary>;
};
